import { Observable } from "rxjs";
import { BaseResponse, AddonsRequestDTO } from "../../models";
import { BundlesConfigurationDto } from "../../models/admin/bundle-conf";

export abstract class BundlesCongfigurationdata {
    abstract getBundlesConfiguration(id?: string): Observable<BaseResponse<any>>;
    abstract addBundlesConfiguration(item: BundlesConfigurationDto,
        id: any): Observable<BaseResponse<BundlesConfigurationDto>>;
    abstract deleteBundlesConfiguration(id?: string): Observable<BaseResponse<BundlesConfigurationDto>>;
 
}
